import { ItemTabs } from 'CMFW/layout/ItemTabs';
import { ModuleContainer } from 'components/common/styles';
import React from 'react';
import ItemsMain from './tabs/ItemsMain';
import ItemSourceGuesser from './tabs/ItemSourceGuesser';
import ItemSourceSentenceTranslationValidator from './tabs/ItemSourceSentenceTranslationValidator';
import ItemSourceMeanValidator from './tabs/ItemSourceMeanValidator';

export type IProps = { courseId: number; search?: string };

const Items: React.FC<IProps> = (props) => {
  return (
    <ModuleContainer>
      <ItemTabs tabNames={['Items', 'Guesser', 'Sentence Validator', 'Mean Validator']}>
        <ItemsMain courseId={props.courseId} search={props.search} />
        <ItemSourceGuesser courseId={props.courseId} />
        <ItemSourceSentenceTranslationValidator courseId={props.courseId} />
        <ItemSourceMeanValidator courseId={props.courseId} />
      </ItemTabs>
    </ModuleContainer>
  );
};

export default Items;
